import styled from '@emotion/styled'
import { calcRem } from 'component-library/__styling/style-functions'

export const StyledIframe = styled('iframe')({
    display: 'block',
    width: '100%',
    height: calcRem(1024),
    border: 0,
})
